import { captureException } from './metrics';
import * as ThumbmarkJS from '@thumbmarkjs/thumbmarkjs';
export async function getFingerprint(): Promise<string | undefined> {
  try {
    const cachedFp = localStorage.getItem('fp');
    if (cachedFp) {
      return cachedFp as string;
    }

    const tm = new ThumbmarkJS.Thumbmark({
      permissions_to_check: ['geolocation', 'camera'],
      stabilize: ['private', 'iframe'],
      timeout: 3000
    });
    const fp = await tm.get();
    const visitorId = fp.thumbmark;
    localStorage.setItem('fp', visitorId);
    return visitorId;
  } catch (error) {
    captureException(error, 'Failed to get fingerprint', {
      section: 'fingerprint'
    });
    return undefined;
  }
}
